import React from 'react'
import css from './monthPicker.module.css'
import { getYear } from 'date-fns'
import cn from '../../../../../utils/cn.ts'

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

interface Props {
  startDate: Date
  endDate?: Date
  currentMonth?: Date
  range?: boolean
  double?: boolean
  onSelect: (date: Date | [Date, Date]) => void
}

const MonthPicker: React.FC<Props> = ({ range, double, currentMonth, startDate, endDate, onSelect }) => {
  const currentYear = currentMonth.getFullYear()

  const isStartMonth = (index: number, year: number) =>
    range && startDate && startDate.getMonth() === index && getYear(startDate) === year
  const isEndMonth = (index: number, year: number) =>
    range && endDate && endDate.getMonth() === index && getYear(endDate) === year
  const isSelected = (index: number, year: number) =>
    !range && getYear(startDate) === year && startDate.getMonth() === index
  const isRange = (index: number, year: number) => {
    return (
      range &&
      startDate &&
      endDate &&
      (year > getYear(startDate) || (year === getYear(startDate) && index > startDate.getMonth())) &&
      (year < getYear(endDate) || (year === getYear(endDate) && index < endDate.getMonth()))
    )
  }
  const handleMonthClick = (index: number, year: number) => {
    onSelect(new Date(year, index))
  }

  const renderMonthPicker = (year: number) => {
    return (
      <div className={css.monthPicker}>
        {months.map((month, index) => {
          return (
            <div
              key={`${month}-${year}`}
              className={cn({
                [css.monthOption]: true,
                [css.selected]: isSelected(index, year),
                [css.rangeStart]: isStartMonth(index, year),
                [css.rangeEnd]: isEndMonth(index, year),
                [css.inRange]: isRange(index, year),
              })}
              onClick={() => handleMonthClick(index, year)}
            >
              {month}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className={css.wrapperContainer}>
      {renderMonthPicker(currentYear)}
      {double && renderMonthPicker(currentYear + 1)}
    </div>
  )
}

export default MonthPicker
